import { createRequestAction } from 'MeetingsBase/utils/actions';
import * as ActionTypes from 'MeetingsAdmin/redux/actions/ActionTypes';
import { List } from 'immutable';
import Raven from 'raven-js';
// @ts-expect-error untyped import
import { fetchLinkStats as fetchLinkStatsRequest } from 'MeetingsAdmin/api/linkStatsAPI';
import MeetingsStats from 'MeetingsBase/models/MeetingsStats';
export const requestedLinkStats = createRequestAction(ActionTypes.LINK_STATS_FETCH_STARTED);
export const receivedLinkStats = createRequestAction(ActionTypes.LINK_STATS_FETCH_SUCCEEDED,
// @ts-expect-error TS2345: TypeScript 5.7.3 stricter function signature checking
linkStatsData => {
  return List(linkStatsData).map(stats => MeetingsStats.from(stats));
});
export const requestedLinkStatsFailed = createRequestAction(ActionTypes.LINK_STATS_FETCH_FAILED,
// @ts-expect-error TS2345: TypeScript 5.7.3 stricter function signature checking
error => ({
  error
}));
export function fetchLinkStats(ids) {
  return dispatch => {
    dispatch(requestedLinkStats());
    // @ts-expect-error plain JS array expected
    fetchLinkStatsRequest(ids).then(linkStatsData => {
      dispatch(receivedLinkStats(linkStatsData));
    }).catch(err => {
      dispatch(requestedLinkStatsFailed(err));
      Raven.captureException(err, {
        extra: {
          message: 'Error fetching link stats'
        }
      });
    });
  };
}